﻿
cb.define([], function() {
	var ST_st_storecheckrealitylist_VM_Extend = {
		doAction: function(name, viewmodel) {
			if(this[name])
				this[name](viewmodel);
		},
		init: function(viewmodel) {
			viewmodel.on('afterInit', function() {
        planViewModel = viewmodel.getCache('parentViewModel');

				viewmodel.getCache('parentViewModel').on("afterReaudit", function(args) {
					debugger
					viewmodel.get('btnAdd').setVisible(false);
				});
			});

			// ====== 共用变量 ======
			var self = this;
			var checkInventorySheetGenerate = false;
      var planViewModel = null;

			viewmodel.on("beforeBatchdelete", function(args) {
				var rowIndex = args.params.params.index;
				return self.beforeDelete(viewmodel, rowIndex);
			});

			viewmodel.on("beforeEdit", function(args) {
				var rowIndex = args.params.params.index;
				return self.beforeEdit(viewmodel, rowIndex);
			});

			// ====== 新增前校验 计划是否已作废或复核 ======
      viewmodel.on("beforeAdd",function(args){
        var planId = planViewModel.get('id').getValue();

        var params = {
          storecheckplan : planId
        };

        var getPlanStatus = cb.rest.DynamicProxy.create({
          settle: {
            url: '/billingretail/getPlanStatus',
            method: 'POST'
          }
        });

        getPlanStatus.settle(params, (err, result) => {
          if(err) {
            cb.utils.alert(err.message, 'error');
            return false;
          }

          if(result === undefined || result == null || result === '') {
            cb.utils.alert("查询盘点计划状态异常！", 'error');
            return false;
          }

          if (result == 1) {
            cb.utils.alert("盘点计划已被复核，不能新增实盘单！", 'error');
            return false;
          } else if (result == 2) {
            cb.utils.alert("盘点计划已被废弃，不能新增实盘单！", 'error');
            return false;
          }

          return;
        });
      });

			var gridModel = viewmodel.getGridModel();
			if(gridModel) {
				//如果没有未审核的实盘单，那么盘点复核页签允许编辑
				gridModel.on("afterSetDataSource", function(args) {
					var params = {
						storecheckplan: viewmodel.getCache('parentViewModel').get('id').getValue()
					};

					var getIfReviewTagActive = cb.rest.DynamicProxy.create({
						settle: {
							url: '/billingretail/getIfReviewTagActive',
							method: 'POST'
						}
					});

					getIfReviewTagActive.settle(params, (err, result) => {
						if(err) {
							cb.utils.alert(err.message, 'error');
							return;
						}

						if(result === undefined || result == null || result === '') {
							cb.utils.alert("查询实盘单状态异常！", 'error');
							return;
						}

						if(result == false) { //盘点复核页签不可点击
							viewmodel.getCache('parentViewModel').execute('updateViewMeta', {
								code: 'fuhe_yeqian',
								disabled: true
							});
						} else if(viewmodel.getCache('parentViewModel').getCache('fuheyeqian')){
							// viewmodel.execute('updateViewMeta', {code:'fuhe_yeqian',disabled:false});
							//如果未复核，那么设置盘点复核页签每次点击的时候都刷新
							var storecheckplanstatus = viewmodel.getCache('parentViewModel').get('status').getValue();
							if(storecheckplanstatus != null && storecheckplanstatus != undefined && storecheckplanstatus !== '' && storecheckplanstatus == 0) {
								viewmodel.getCache('parentViewModel').execute('updateViewMeta', {
									code: 'fuhe_yeqian',
									disabled: false,
									refresh: true
								});
							} else { //如果已复核，设置复核页签只有第一次点击时刷新查询数据，并且设置新增按钮不可见
								viewmodel.getCache('parentViewModel').execute('updateViewMeta', {
									code: 'fuhe_yeqian',
									disabled: false,
									refresh: false
								});
								if(viewmodel.get('btnAdd')) {
									viewmodel.get('btnAdd').setVisible(false);
								}
							}
						}

					});
				});
			}

		},

		beforeDelete: function(viewmodel, rowIndex) {
			var currentRow = viewmodel.getGridModel().getRow(rowIndex);
			if(currentRow.status === 1) {
				cb.utils.alert("已审核的单据不允许删除！");
				return false;
			}
		},

		beforeEdit: function(viewmodel, rowIndex) {
			var currentRow = viewmodel.getGridModel().getRow(rowIndex);
			if(currentRow.status === 1) {
				cb.utils.alert("已审核的单据不允许编辑！");
				return false;
			}
		}
	};
	try {
		module.exports = ST_st_storecheckrealitylist_VM_Extend;
	} catch(error) {

	}
	return ST_st_storecheckrealitylist_VM_Extend;
});



// WEBPACK FOOTER //
// ./src/client/business/ST/ST_st_storecheckrealitylist_VM.Extend.js